import React, { useState, useContext } from 'react';
import RemoveLastDirectoryPartOf from '../goBackButton';
import { Button, Alert } from 'tabler-react';
import { hasUpper, hasNumber, hasSpecialchar } from '../validation';
import './ChangePassword.css';
import { useAPI } from '../../ApiCalls/useAPI';
import { MyContext } from '../../context/MyContext';

const ChangePassword = () => {
    const [flag, setFlag] = useState(false);
    const [newp, setNewp] = useState('');
    const [cnewp, setCnewp] = useState('');
    const [status, setStatus] = useState('');
    const [statusmsg, setStatusmsg] = useState('');
    const context = useContext(MyContext);

    const backtologin = (the_url) => {
        var the_arr = the_url.split('/');
        the_arr.pop();
        the_arr.push('login');
        return the_arr.join('/');
    };
    function checknewpass() {
        var pswd = document.getElementById('newp').value;
        setNewp(pswd);
        if (pswd === '') {
            document.getElementById('message2').innerHTML =
                '**Fill the password please!';
            document.getElementById('newp').classList.remove('is-valid');
            document.getElementById('newp').classList.add('is-invalid');
            return false;
        }
        if (pswd.length < 8) {
            document.getElementById('message2').innerHTML =
                '**Password length must be atleast 8 characters';
            document.getElementById('newp').classList.remove('is-valid');
            document.getElementById('newp').classList.add('is-invalid');
            return false;
        }
        if (!hasUpper(pswd)) {
            document.getElementById('message2').innerHTML =
                '**Password must contain a Uppercase letter';
            document.getElementById('newp').classList.remove('is-valid');
            document.getElementById('newp').classList.add('is-invalid');
            return false;
        }
        if (!hasNumber(pswd)) {
            document.getElementById('message2').innerHTML =
                '**Password must contain a number';
            document.getElementById('newp').classList.remove('is-valid');
            document.getElementById('newp').classList.add('is-invalid');
            return false;
        }
        // if (!hasSpecialchar(pswd)) {
        //     document.getElementById('message2').innerHTML =
        //         '**Password must contain a Special character';
        //     document.getElementById('newp').classList.remove('is-valid');
        //     document.getElementById('newp').classList.add('is-invalid');
        //     return false;
        // }
        if (pswd.length > 15) {
            document.getElementById('message2').innerHTML =
                '**Password length must not exceed 15 characters';
            document.getElementById('newp').classList.remove('is-valid');
            document.getElementById('newp').classList.add('is-invalid');
            return false;
        } else {
            document.getElementById('message2').innerHTML = '';
            document.getElementById('newp').classList.remove('is-invalid');
            document.getElementById('newp').classList.add('is-valid');
            if (pswd !== cnewp) {
                setFlag(false);
                if (cnewp !== '') {
                    document.getElementById('message3').innerHTML =
                        '**Passwords does not match';
                    document
                        .getElementById('cnewp')
                        .classList.remove('is-valid');
                    document
                        .getElementById('cnewp')
                        .classList.add('is-invalid');
                }
                return false;
            } else {
                document.getElementById('message3').innerHTML = '';
                setFlag(true);
            }
        }
    }
    function checknewcpass() {
        var pswd = document.getElementById('cnewp').value;
        setCnewp(pswd);
        if (pswd === '') {
            document.getElementById('message3').innerHTML =
                '**Fill the password please!';
            document.getElementById('cnewp').classList.remove('is-valid');
            document.getElementById('cnewp').classList.add('is-invalid');
            return false;
        }
        if (pswd !== newp) {
            setFlag(false);
            document.getElementById('message3').innerHTML =
                '**Passwords does not match';
            document.getElementById('cnewp').classList.remove('is-valid');
            document.getElementById('cnewp').classList.add('is-invalid');
            return false;
        } else {
            document.getElementById('message3').innerHTML = '';
            document.getElementById('cnewp').classList.add('is-valid');
            document.getElementById('cnewp').classList.remove('is-invalid');
            setFlag(true);
        }
    }
    function onSubmitClicked() {
        // console.log('new password is', newp);
        const { setPassword } = useAPI();
        setPassword(newp)
            .then((response) => {
                // console.log(response);
                if (response === 1) {
                    setStatus('Password changed successfully');
                    setStatusmsg('Redirecting to Login page in 3 seconds ...');
                    setTimeout(() => {
                        context.logoutUser();
                        window.location.href = backtologin(
                            window.location.href
                        );
                    }, 3000);
                } else {
                    setStatus('Please Try Again Later');
                }
            })
            .catch((error) => console.error(error));
    }
    const { first_login } = useContext(MyContext);
    return (
        <div className="container">
            <div className="m-2" style={{ fontSize: '20px', display: 'flex' }}>
                <div className="mr-4">
                    <a
                        href={RemoveLastDirectoryPartOf(window.location.href)}
                        style={{ textDecoration: 'none' }}
                    >
                        <i className="fe fe-arrow-left" />
                    </a>
                </div>
                <div>Change Password</div>
            </div>
            <div className="changepass">
                {first_login ? (
                    <Alert type="danger">
                        Your password has been reset. Please change your
                        password now.
                    </Alert>
                ) : (
                    <div></div>
                )}
                <h2 className="changepasshead">Change Password</h2>
                {/* {state.errorMsg && <div className="error-msg">{state.errorMsg}</div>} */}
                <div id="changepassform">
                    <h6 id="headerTitlechangepass">Enter the new password</h6>
                    <div>
                        <div className="mt-2 changepassrow form-group">
                            <label className="changepass_label form-label">
                                New Password
                            </label>
                            <input
                                className="form-control"
                                id="newp"
                                type="password"
                                value={newp}
                                onChange={checknewpass}
                                placeholder="New Password"
                            />
                            <div id="message2"></div>
                        </div>
                        <div className="mt-2 changepassrow form-group">
                            <label className="changepass_label form-label">
                                Confirm Password
                            </label>
                            <input
                                className="form-control"
                                id="cnewp"
                                type="password"
                                value={cnewp}
                                onChange={checknewcpass}
                                placeholder="Confirm Password"
                            />
                            <div id="message3"></div>
                        </div>
                        <div id="button" className="changepassrow">
                            <Button
                                color="primary"
                                className="mt-4"
                                disabled={!flag}
                                onClick={onSubmitClicked}
                            >
                                Change Password
                            </Button>
                        </div>
                        <div className="mt-4">
                            <h5 style={{ color: 'rgb(165, 228, 165)' }}>
                                {status}
                            </h5>
                            <p>{statusmsg}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChangePassword;
